import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../uicomponentcss';

export interface SearchBoxToneOptionCSSStyle extends UIComponentCSSStyle
{
    getMainDivCSSStyle():object;
    getMobileMainDivCSSStyle():object;
    getSearchBoxImageDivCSSStyle():object;
    getMobileSearchBoxImageDivCSSStyle():object;
    getSearchBoxInputDivCSSStyle():object;
    getSearchLabelCSSStyle():object;
    getMobileSearchLabelCSSStyle():object;
    getDropDownSSStyle():object;
    getMobileDropDownSSStyle():object;
    getErrorTextDivCSSStyle(): object;
    getErrorTextCSSStyle(language:any): object;
    getMobileSearchBoxInputDivCSSStyle():object;
}
export class SearchBoxToneOptionCSSStyleImpl extends UIComponentCSSStyleImpl implements SearchBoxToneOptionCSSStyle
{
    getMainDivCSSStyle(): object 
    {
        return{
            width:'100%',height:'61px',borderRadius:'30px',backgroundColor:this.getResources().getColor(Colors.color_5),
            border:'1px solid'+this.getResources().getColor(Colors.color_8),
        
        };
    } 
    getMobileMainDivCSSStyle(): object 
    {
        return{
            width:'100%',height:'40px',borderRadius:'30px',backgroundColor:this.getResources().getColor(Colors.color_5),
            border:'1px solid'+this.getResources().getColor(Colors.color_8),
    
        };
    }    
    getErrorTextDivCSSStyle(): object 
    {
        return {
           display: "flex"
        };
    }

    getErrorTextCSSStyle(language:any): object {
        return {
            color: this.getResources().getColor(Colors.color_12),
            fontSize: this.getResources().getFont(Fonts.h5),
            margin:'5px 0px 0px auto'
        };
    } 
    getSearchBoxImageDivCSSStyle(): object {
        return{
            width:"150px", height:"100%",
            backgroundColor:"#EAEDF0", 
            float:'left',
            borderRadius:'30px 0px 0px 30px',
            cursor: "pointer"
        };
    }
    getMobileSearchBoxImageDivCSSStyle(): object {
        return{
            minWidth:"80px", height:"100%",
            backgroundColor:"#EAEDF0", 
            float:'left',
            borderRadius:'30px 0px 0px 30px',
            cursor: "pointer"
        };
    }
    getSearchLabelCSSStyle():object
    {
        return{
            width:'100%',height:'40px',lineHeight:'40px',marginTop:'10px',fontSize:'20px',fontWeight:600,
            color:'#003187',
            textAlign:'center',
            cursor: "pointer"
        };
    }
    getMobileSearchLabelCSSStyle():object
    {
        return{
            width:'100%',height:'30px',lineHeight:'30px',marginTop:'5px',fontSize:'12px',fontWeight:600,
            color:'#003187',
            textAlign:'center',
            cursor: "pointer"
        };
    }
    getDropDownSSStyle(): object 
    {
        return {
            width: "150px",
            marginTop: "5px",
            position: "absolute",
            zIndex: 2,
            borderRadius:'8px',
            // border: '1px solid #EAECEF',
            backgroundColor: this.getResources().getColor(Colors.color_5)
        };
    }
    getMobileDropDownSSStyle(): object 
    {
        return {
            width: "100px",
            marginTop: "5px",
            position: "absolute",
            zIndex: 2,
            borderRadius:'8px',
            // border: '1px solid #EAECEF',
            backgroundColor: this.getResources().getColor(Colors.color_5)
        };
    }
    getSearchBoxInputDivCSSStyle(): object 
    {
        return{
            width:"90%",
            height:this.getContext().getUserContext().getLanguage() === LanguageConst.BURMESE?'44px':"41px", paddingTop:'25px', 
            lineHeight:this.getContext().getUserContext().getLanguage() === LanguageConst.BURMESE?'44px':"41px", paddingBottom:'10px',
            marginLeft:'24px', marginRight:'10px',outline:'none',border:'none',
            fontSize:this.getResources().getFont(Fonts.h10),
            fontWeight: 300,
            letterSpacing: 0,
            focus:'none',
            color:this.getResources().getColor(Colors.color_9),
            fontFamily: this.getResources().getFontFamily(),
            backgroundColor:this.getResources().getColor(Colors.color_5),
        };
    }

    getMobileSearchBoxInputDivCSSStyle(): object 
    {
        return{
            width:"80%",
            height:this.getContext().getUserContext().getLanguage() === LanguageConst.BURMESE?'33px':"30px", paddingTop:'18px', lineHeight:this.getContext().getUserContext().getLanguage() === LanguageConst.BURMESE?'33px':"30px", paddingBottom:'18px',
            marginLeft:'17px', marginRight:'10px',outline:'none',border:'none',
            fontSize:"14px",
            fontWeight: 300,
            letterSpacing: 0,
            focus:'none',
            color:this.getResources().getColor(Colors.color_9),
            fontFamily: this.getResources().getFontFamily(),
            backgroundColor:this.getResources().getColor(Colors.color_5),
        };
    }

  
  
    
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toolbarwithsearch/searchbox/searchboxtoneoption/searchboxtoneoptioncss.tsx